import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'

import Header from './sections/header/containers/header'
import Footer from './sections/footer/components/footer'
import SimpleSnackbar from './common/containers/simpleSnackbar'
import Community from './sections/community/containers/community'
import Yours from './sections/yours/containers/yours'
import Catalog from './sections/catalog/containers/catalog'
import Shared from './sections/shared/containers/shared'
import Profile from './sections/profile/containers/profile'
import Activity from './sections/activity/containers/container'
import Balance from './sections/balance/containers/balance'
import Billing from './sections/billing/containers/billing'
import Help from './sections/help/containers/help'
import Recover from './sections/recover/Recover'
import Item from './sections/items/containers/item'
import YourItem from './sections/yourItems/containers/item'
import ConfirmEmail from './sections/confirmEmail/containers/confirmEmail'
import FaqCategories from './sections/help/containers/faqCategories'
import Faqs from './sections/help/containers/faqs'
import Contact from './sections/help/containers/contact'
import Redirection from './sections/redirection/redirection'
import Landing from './state/landing/landing'
import Terms from "./sections/terms/containers/Terms"
import TermsDeposit from "./sections/termsDeposit/containers/TermsDeposit"
import AddCreditCard from "./sections/addCreditCard/containers/AddCreditCard"

export const RENT_AVAILABLE = false
export const PRICES_AVAILABLE = false

const rentRoute = RENT_AVAILABLE
    ? <Route exact path="/" component={Community}/>
    : <Route exact path="/" render={(props) => {
      return <Redirect to={'/micatalogo' + props.location.search}/>
    }}/>

class App extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path='/:countryCode/tyc/:code' component={Terms}/>
        <Route exact path='/depositotyc' component={TermsDeposit}/>
        <Route exact path='/tarjeta/:code' component={AddCreditCard}/>
        <Route path='/' component={MainApp}/>
      </Switch>
    )
  }
}

const MainApp = () => (
  <div style={{paddingTop: 107, boxSizing: 'border-box'}}>
    <Header/>
    <div style={{minHeight: 520}}>
      <Switch>
        {rentRoute}

        <Route exact path="/recuperar" component={Recover}/>

        <Route exact path="/micatalogo" component={Yours}/>
        <Route exact path="/catalogo/:id" component={Catalog}/>

        <Route exact path="/compartido" component={Shared}/>

        <Route exact path="/confirmar" component={ConfirmEmail}/>

        <Route path="/objetos/:id/edit" component={YourItem}/>

        <Route path="/objetos/:id" component={Item}/>

        <Route exact path="/perfil" component={Profile}/>
        <Route exact path="/actividad" component={Activity}/>
        <Route exact path="/balance" component={Balance}/>
        <Route exact path="/facturacion" component={Billing}/>
        <Route exact path="/ayuda" component={Help}/>
        <Route exact path="/ayuda/faqs" component={FaqCategories}/>
        <Route exact path="/ayuda/faqs/:id" component={Faqs}/>
        <Route exact path="/ayuda/contacto" component={Contact}/>

        <Route exact path="/redireccionando" component={Redirection}/>

        <Redirect to="/"/>

      </Switch>
    </div>
    <Footer/>
    <Landing/>
    <SimpleSnackbar/>
  </div>
)

App.propTypes = {}

export default App



// WEBPACK FOOTER //
// ./src/App.js